// @flow
import React, { type Element } from 'react';
import Training from './training/Training';

const PageTrainings = (): Element<*> => (
    <Training />
);

export default PageTrainings;
